// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"4854f007","876":"ccc4f0d5"}[chunkId] + ".chunk.css";
};